export const strapiLinearGradients = {
  'linearGradient.one': '90deg, #1B41FB -4.67%, #DA88D2 36.31%, #FDA740 92.02%',
  'linearGradient.white': '90deg, #fff -4.67%, #fff 36.31%, #fff 92.02%',
}
